module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "weui-navbar"
  }, [_vm._l((_vm.tabs), function(tab, i) {
    return [_c('div', {
      class: [{
        'weui-bar__item_on': i === _vm.tabIndex
      }, 'weui-navbar__item'],
      on: {
        "click": function($event) {
          _vm.tabChange(i)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab) + "\n    ")])]
  })], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-748488fc!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/tab-bar.vue
// module id = 265
// module chunks = 0